import React from 'react';
import {View, StyleSheet} from 'react-native';
import Styles from '../../../Styles';
import AVText from '../../../elements/AVText';
import {getDescriber} from '../../../elements/descriptor/DescriptorType';
import {getLayoutDescriber} from '../../../elements/layoutDescriptor/DescriptorType';

interface SubsidyDetailRowProps {
  title: string;
  value: string | string[];
  showSeparator?: boolean;
  testID?: string;
}

export const SubsidyDetailRow: React.FC<SubsidyDetailRowProps> = ({
  title,
  value,
  showSeparator = true,
  testID,
}) => {
  const renderValue = () => {
    if (typeof value === 'string') {
      return (
        <AVText
          style={styles.value}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
          accessible={true}
          accessibilityLabel={`${title}: ${value}`}
        >
          {value}
        </AVText>
      );
    }

    if (Array.isArray(value)) {
      return (
        <>
          {value.map((item, index) => (
            <AVText
              key={index}
              style={[
                styles.value,
                index < value.length - 1 && styles.valueSpacing,
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
              accessible={true}
              accessibilityLabel={`${title}: ${item}`}
            >
              {item}
            </AVText>
          ))}
        </>
      );
    }

    return null;
  };

  return (
    <View accessible={true} testID={testID}>
      <View style={styles.container}>
        <AVText
          style={styles.title}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
          accessible={true}
          accessibilityLabel={title}
        >
          {title}
        </AVText>

        <View style={styles.valueContainer}>{renderValue()}</View>
      </View>

      {showSeparator && (
        <View style={styles.separatorContainer}>
          <View style={styles.separator} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: 0,
  },
  title: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: Styles.darkColor,
    fontFamily: getDescriber().walletForntStyleText(),
    marginBottom: Styles.Spacing.m1,
  },
  valueContainer: {
    marginTop: 4,
  },
  value: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    color: Styles.darkColor,
    fontFamily: getDescriber().walletForntStyleText(),
    lineHeight: 24,
  },
  valueSpacing: {
    marginBottom: Styles.Spacing.m14,
  },
  separatorContainer: {
    paddingHorizontal: 0,
    marginVertical: Styles.Spacing.m1,
  },
  separator: {
    height: 1,
    backgroundColor: Styles.Colors.PayNew.neutralHuesBase09 || '#E0E0E0',
  },
});
